import { useGetAppRoles } from "./useGetAppRoles";
import { useHasRole } from "./useHasRole";

/** Client role carried by the Keycloak group `beta-widgets-preview-group`. */
export const BETA_WIDGETS_ROLE = "beta-widgets";

/**
 * Whether the user is in the beta preview cohort.
 *
 * The role is assigned on the `react-frontend-client` client, but this realm's
 * role mapper emits those roles under `resource_access.app` — a UAT token for a
 * group member carries `beta-widgets` in `app.roles` and has no
 * `react-frontend-client` entry at all. Prod runs a separate Keycloak server, so
 * the client-named resource is checked as a fallback rather than assuming both
 * servers map roles identically.
 */
export const useHasBetaWidgetsRole = (): boolean => {
  const appRoles = useGetAppRoles();
  const hasClientRole = useHasRole(BETA_WIDGETS_ROLE);

  return appRoles.includes(BETA_WIDGETS_ROLE) || hasClientRole;
};
